export default __webpack_public_path__ + "static/media/cnp-map.4681fe1f.png";